import { render, staticRenderFns } from "./RepairMarkModal.vue?vue&type=template&id=68e2f60f&scoped=true"
import script from "./RepairMarkModal.vue?vue&type=script&lang=js"
export * from "./RepairMarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e2f60f",
  null
  
)

export default component.exports